// src/components/common/bulk/ValidationResults.jsx
import React from 'react';
import { CheckCircle, XCircle, AlertCircle, RefreshCw, PhoneOff } from 'lucide-react';
import styles from './ValidationResults.module.css';

const ValidationResults = ({
  results,
  onRetry,
  isProcessing,
  title = 'Validation Results',
  validLabel = 'Valid Orders',
  invalidLabel = 'Invalid Orders',
  totalLabel = 'Total Orders',
  errorSummaryTitle = 'Please fix the following errors:',
}) => {
  const { summary } = results;

  return (
    <div className={styles.validationResults}>
      <div className={styles.header}>
        <h3>{title}</h3>
        {summary.failureCount > 0 && (
          <button
            onClick={onRetry}
            disabled={isProcessing}
            className={styles.retryButton}
          >
            <RefreshCw size={16} />
            Retry Validation
          </button>
        )}
      </div>

      <div className={styles.summaryCards}>
        <div className={styles.card}>
          <div className={styles.cardIcon}>
            <CheckCircle size={32} />
          </div>
          <div className={styles.cardContent}>
            <div className={styles.cardValue}>{summary.validCount}</div>
            <div className={styles.cardLabel}>{validLabel}</div>
          </div>
        </div>

        <div className={`${styles.card} ${styles.error}`}>
          <div className={styles.cardIcon}>
            <XCircle size={32} />
          </div>
          <div className={styles.cardContent}>
            <div className={styles.cardValue}>{summary.failureCount}</div>
            <div className={styles.cardLabel}>{invalidLabel}</div>
          </div>
        </div>

        {summary.blacklistedCount > 0 && (
          <div className={`${styles.card} ${styles.blacklisted}`}>
            <div className={styles.cardIcon}>
              <PhoneOff size={32} />
            </div>
            <div className={styles.cardContent}>
              <div className={styles.cardValue}>{summary.blacklistedCount}</div>
              <div className={styles.cardLabel}>Blacklisted Phones</div>
            </div>
          </div>
        )}

        <div className={styles.card}>
          <div className={styles.cardIcon}>
            <AlertCircle size={32} />
          </div>
          <div className={styles.cardContent}>
            <div className={styles.cardValue}>{summary.totalSubmitted}</div>
            <div className={styles.cardLabel}>{totalLabel}</div>
          </div>
        </div>
      </div>

      {summary.failureCount > 0 && (
        <div className={styles.errorSummary}>
          <h4>{errorSummaryTitle}</h4>
          <ul>
            {results.results
              .filter(r => r.status === 'failed')
              .map(r => (
                <li key={r.rowNumber}>
                  Row {r.rowNumber}: {r.errors.join(', ')}
                </li>
              ))}
          </ul>
        </div>
      )}

      {summary.blacklistedCount > 0 && (
        <div className={styles.blacklistedSummary}>
          <PhoneOff size={16} />
          <div>
            <h4>Orders with blacklisted phone numbers:</h4>
            <ul>
              {results.results
                .filter(r => r.isBlacklisted)
                .map(r => (
                  <li key={r.rowNumber}>
                    Row {r.rowNumber}: {r.blacklistedPhones.join(', ')}
                  </li>
                ))}
            </ul>
            <p>These orders can still be submitted. Use the &quot;Remove blacklisted&quot; button in the table above to exclude them.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ValidationResults;
